import React from "react";


const Loading = ({ children }) => {
  return (
    <div id="loader">{children}</div>
  );
};

export default Loading;

// for component data loader
export const Loader = ({ children, loading = false, className, msg = '' }) => {
  if (loading) {
    return (
      // <div className={`${className}`}>
      <div id="loader">
        <span className="loader-17"></span>
        {children}
        {msg && <p className="loaderMsg">{msg}</p>}
        </div>
      // </div>
    );
  }
  return <>{children}</>;
};
